import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  DeleteVendorSlice,
  GetVendorListSlice,
  UpdateVendorSlice,
} from "../../../redux/features/VendorManagementSlice";
import { GetVendorCategoryListDropDownSlice } from "../../../redux/features/VendorCategoryManagementSlice";
import { GetVendorCityListDropDownSlice } from "../../../redux/features/VendorCityManagementSlice";
import { Loader } from "../../../common/Loader/Loader";
import useParamsFormat from "../../../common/Params Values format/ParamsFormat";
import Pagination from "../../../common/pagination/PaginationCustom";

const VendorsList = () => {
  const dispatch = useDispatch();
  const [vendors, setVendors] = useState([]);
  const [dataForHold, setDataForHold] = useState();
  const [pagination, setPagination] = useState([]);
  const [handleArrforPage, setHandleArrforPage] = useState(1);
  const [arr, setArr] = useState([]);
  const [page, setPage] = useState(1);
  const [getSearch, setGetSearch] = useState({
    search: "",
    city: "",
    category: "",
    status: "",
    page: 1,
  });

  const { createDataSetParams } = useParamsFormat();

  const { loading, createdVendor, updatedVendor, deletedVendor } = useSelector(
    (state) => state.VendorManagement
  );
  const { CategoryListDropDown } = useSelector((state) => state.VendorCategoryManagement);
  const { CityListDropDown } = useSelector((state) => state.VendorCityManagement);

  const fetchList = (search = getSearch) => {
    dispatch(GetVendorListSlice(createDataSetParams(search))).then((res) => {
      setVendors(res?.payload?.data?.vendors);
      setPagination(res?.payload?.data?.pagination);
    });
  };

  useEffect(() => {
    dispatch(GetVendorCategoryListDropDownSlice());
    dispatch(GetVendorCityListDropDownSlice());
  }, []);

  useEffect(() => {
    fetchList();
  }, [createdVendor, updatedVendor, deletedVendor]);

  useEffect(() => {
    if (Object.entries(pagination ?? {}).length > 0) {
      setArr(
        [...Array(pagination?.totalPages + 1).keys()]
          .slice(1)
          .slice(handleArrforPage - 1, handleArrforPage + 3)
      );
    }
  }, [pagination, handleArrforPage]);

  const handlePagesIncrease = () => {
    if (handleArrforPage + 3 <= pagination?.totalPages) {
      setHandleArrforPage((prev) => prev + 3);
    }
  };

  const handlePagesDecrease = () => {
    if (handleArrforPage > 2) {
      setHandleArrforPage((prev) => prev - 3);
    }
  };

  const FetchDataOnPages = (pageNum) => {
    setPage(pageNum);
    const updatedSearch = { ...getSearch, page: pageNum };
    setGetSearch(updatedSearch);
    fetchList(updatedSearch);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const updatedSearch = { ...getSearch, [name]: value, page: 1 };
    setGetSearch(updatedSearch);
    setPage(1);
  };

  const handleApplyFilters = () => {
    fetchList(getSearch);
  };

  const handleResetFilters = () => {
    const resetSearch = { search: "", city: "", category: "", status: "", page: 1 };
    setGetSearch(resetSearch);
    setPage(1);
    fetchList(resetSearch);
  };

  const handleDelete = () => {
    dispatch(DeleteVendorSlice(dataForHold)).then(() => {
      fetchList();
    });
  };

  const handleToggleStatus = (item) => {
    dispatch(
      UpdateVendorSlice({
        id: item?._id,
        data: { isActive: !item?.isActive },
      })
    ).then(() => {
      fetchList();
    });
  };

  return (
    <>
      <div className="TitleBox">
        <h2>All Vendors</h2>
        <Link to={"/VendorManagement/Vendors/AddVendor"} className="Button">
          Add Vendor
        </Link>
      </div>

      <div className="Small-Wrapper">
        <div className="Filter justify-content-between">
          <div className="FilterLeft">
            <div className="form-group">
              <label>Search</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search vendor name / mobile / address / pincode"
                name="search"
                value={getSearch.search}
                onChange={handleFilterChange}
              />
            </div>
            <div className="form-group">
              <label>City</label>
              <select className="form-control" name="city" value={getSearch.city} onChange={handleFilterChange}>
                <option value="">All Cities</option>
                {Array.isArray(CityListDropDown) &&
                  CityListDropDown?.map((item) => (
                    <option key={item?._id} value={item?._id}>
                      {item?.cityName}
                    </option>
                  ))}
              </select>
            </div>
            <div className="form-group">
              <label>Category</label>
              <select className="form-control" name="category" value={getSearch.category} onChange={handleFilterChange}>
                <option value="">All Categories</option>
                {Array.isArray(CategoryListDropDown) &&
                  CategoryListDropDown?.map((item) => (
                    <option key={item?._id} value={item?._id}>
                      {item?.categoryName}
                    </option>
                  ))}
              </select>
            </div>
            <div className="form-group">
              <label>Status</label>
              <select className="form-control" name="status" value={getSearch.status} onChange={handleFilterChange}>
                <option value="">All</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="form-group">
              <label>&nbsp;</label>
              <button className="Button" style={{ marginRight: "10px" }} onClick={handleApplyFilters}>
                Apply
              </button>
              <button className="Button Cancel" onClick={handleResetFilters}>
                <i className="fa fa-refresh" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="TableList">
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>Business Name</th>
              <th>Owner</th>
              <th>Contact Person</th>
              <th>Mobile</th>
              <th>City</th>
              <th>Categories</th>
              <th>Status</th>
              <th>Created Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {!loading ? (
              Array.isArray(vendors) && vendors?.length > 0 ? (
                vendors?.map((item, index) => {
                  return (
                    <tr key={item?._id || index}>
                      <td>{(pagination?.currentPage - 1) * 10 + index + 1}</td>
                      <td>{item?.businessName}</td>
                      <td>{item?.ownerName}</td>
                      <td>{item?.contactPersonName}</td>
                      <td>{item?.mobile1}</td>
                      <td>{item?.cityName}</td>
                      <td>{Array.isArray(item?.categoryNames) ? item.categoryNames.join(", ") : ""}</td>
                      <td>
                        <span className={item?.isActive ? "Green" : "Red"}>
                          {item?.isActive ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>{item?.createdAt?.substring(0, 10)}</td>
                      <td>
                        <div className="Actions">
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={item?.isActive}
                              onChange={() => handleToggleStatus(item)}
                            />
                            <span className="slider" />
                          </label>
                          <Link to={`VendorDetails/${item._id}`} className="Blue">
                            <i className="fa fa-eye" />
                          </Link>
                          <Link to={`EditVendor/${item._id}`} className="Green">
                            <i className="fa fa-pencil" />
                          </Link>
                          <a
                            className="Red"
                            data-toggle="modal"
                            data-target="#DeleteModal"
                            onClick={() => setDataForHold(item?._id)}
                          >
                            <i className="fa fa-trash" />
                          </a>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={10}>There are no vendors</td>
                </tr>
              )
            ) : (
              <Loader />
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <Pagination
          arr={arr}
          page={page}
          handlePagesIncrease={handlePagesIncrease}
          FetchDataOnPages={FetchDataOnPages}
          handlePagesDecrease={handlePagesDecrease}
        />
      </div>

      <div className="ModalBox">
        <div id="DeleteModal" className="modal fade" style={{ display: "none" }} aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Decline">
                  <a href="javascript:void(0);" className="CloseModal" data-dismiss="modal">
                    ×
                  </a>
                  <h3>Delete</h3>
                  <p>Are you sure you want to Delete this Vendor?</p>
                  <h4>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      no
                    </a>
                    <a href="javascript:void(0);" data-dismiss="modal" onClick={handleDelete}>
                      Yes
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorsList;
